export default __webpack_public_path__ + "static/media/immagine michele moliteo.fd9827fe.jpg";